import { CSSProperties } from 'react';
import classes from './Breadcumb.module.css'
import { RightIcon } from '../Icons';
import Link from 'next/link';

interface Props {
    className?: string;
    style?: CSSProperties;

    items: {
        name: string;
        link?: string;
    }[];
}

const Breadcumb = ({
    className,
    style,

    items,
}: Props) => {
    const classNames = [classes.Breadcumb, className, 'hide-scrollbar'];
    
    return (
        <div className={classNames.join(' ')} style={style}>
            {items.map((item, index) => (
                item.link ? (
                    <Link key={index + '-breadcumb-item'}
                        href={item.link}
                        className={classes.item}
                    >
                        <p className={classes.name}>
                            {item.name}
                        </p>

                        {index !== items.length - 1 && (
                            <RightIcon 
                                className={classes.icon}
                                width={14}
                            />
                        )}
                    </Link>
                ) : (
                    <div key={index + '-breadcumb-item'}
                        className={classes.item}
                    >
                        <p className={classes.name}>
                            {item.name}
                        </p>

                        {index !== items.length - 1 && (
                            <RightIcon 
                                className={classes.icon}
                                width={14}
                            />
                        )}
                    </div>
                )
            ))}
        </div>
    )
}

export default Breadcumb